import React, { Component } from 'react';
import { Accordion, Icon, Button, Table } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { addDays, format } from 'date-fns';
import pt from 'date-fns/locale/pt';
import _ from 'lodash';
// local
import './RequestDelivery.scss';
// views
import ConfirmModal from './ConfirmModal';
import RequestTableRow from './RequestTableRow';
import Page from 'app/ui/pages/Page';
import EmptyList from 'app/ui/commons/emptyList/EmptyList';
// actions
import { listPendingDelivery, savePendingDelivery, resetPendingDelivery } from 'app/redux/actions/requestDelivery/data';
import { openModal } from 'app/redux/actions/requestDelivery/modal';

class RequestDelivery extends Component {
    constructor(props) {
        super(props);
        this.state = { active: [] };
    }

    componentDidMount = () => this.props.dispatch(listPendingDelivery());

    componentWillUnmount = () => this.props.dispatch(resetPendingDelivery());

    handleClick = (e, prop) => {
        const { active } = this.state;
        const { index } = prop;
        const pos = active.indexOf(index);
        if (pos === -1) {
            active.push(index);
        } else {
            active.splice(pos, 1);
        }
        this.setState({ active });
    };

    isActive = index => this.state.active.indexOf(index) === -1;

    onClickConfirm = () => this.props.dispatch(savePendingDelivery(this.props.requestDelivery.suppliers));

    onClickRequest = () => {
        const patients = [];
        // get all the patients with empty cylinders
        this.props.requestDelivery.suppliers.forEach(supplier => {
            supplier.patients.forEach(patient => {
                if (patient.emptyCylinderQtd + patient.pendingCylinderQtd > patient.pendingCylinderQtdEdit) {
                    patients.push(patient);
                }
            });
        });
        if (patients.length > 0) {
            this.props.dispatch(openModal(patients));
        } else {
            this.onClickConfirm();
        }
    };

    renderEmpty = () => <EmptyList emptyMessage="Nenhuma solicitação a ser feita." />;

    renderData(totalPendingCylinders, suppliers) {
        return (
            <React.Fragment>
                <Accordion fluid>
                    {_.map(suppliers, supplier => {
                        const key = `supplier-${supplier.id}`;
                        return (
                            <React.Fragment key={key}>
                                <Accordion.Title active={this.isActive(supplier.id)} index={supplier.id} onClick={this.handleClick}>
                                    <Icon name="dropdown" /> {supplier.name}
                                    <div className="cylinders-numbers">{supplier.pendingCylinderQtd}</div>
                                </Accordion.Title>
                                <Accordion.Content active={this.isActive(supplier.id)}>
                                    <Table className="patient-table">
                                        <Table.Header>
                                            <Table.Row>
                                                <Table.HeaderCell width="1">ATM</Table.HeaderCell>
                                                <Table.HeaderCell width="5">PACIENTE</Table.HeaderCell>
                                                <Table.HeaderCell width="5">ENDEREÇO</Table.HeaderCell>
                                                <Table.HeaderCell textAlign="center" width="3">
                                                    TIPO
                                                </Table.HeaderCell>
                                                <Table.HeaderCell textAlign="center" width="1">
                                                    QUANTIDADE
                                                </Table.HeaderCell>
                                                <Table.HeaderCell width="1" />
                                            </Table.Row>
                                        </Table.Header>
                                        <Table.Body>
                                            {_.map(supplier.patients, patient => {
                                                const key = `patient-${patient.id}`;
                                                return <RequestTableRow key={key} row={patient} />;
                                            })}
                                        </Table.Body>
                                    </Table>
                                </Accordion.Content>
                            </React.Fragment>
                        );
                    })}
                </Accordion>
                <div className="accordion-footer">
                    <div id="total-cylinders-title">TOTAL DE CILINDROS</div>
                    <div id="total-cylinders-value">{totalPendingCylinders}</div>
                </div>
            </React.Fragment>
        );
    }

    render() {
        const { totalPendingCylinders, suppliers, loading } = this.props.requestDelivery;
        const tomorrow = addDays(new Date(), 1);
        const isEmpty = _.isEmpty(suppliers);
        return (
            <Page id="page-request-delivery" loading={loading}>
                <div className="page-header">
                    <div className="page-title">
                        Solicitações de cilindros à serem entregues amanhã: <span className="bold">{format(tomorrow, 'dddd, DD/MM/YYYY', { locale: pt })}</span>
                    </div>
                    <div className="flex-right">
                        <Button content="SOLICITAR" onClick={this.onClickRequest} disabled={isEmpty} />
                    </div>
                </div>
                <div className="body">{isEmpty ? this.renderEmpty() : this.renderData(totalPendingCylinders, suppliers)}</div>
                <ConfirmModal onClickConfirm={this.onClickConfirm} />
            </Page>
        );
    }
}

RequestDelivery.propTypes = {
    dispatch: PropTypes.func,
    requestDelivery: PropTypes.object,
};

const mapStateToProps = state => ({
    requestDelivery: state.requestDelivery,
});
export default connect(mapStateToProps)(RequestDelivery);
